// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"a1c0ac25","604":"c7bea6ab","797":"70f7c38e"}[chunkId] + ".chunk.css";
};